import { jsxs as l, jsx as e } from "react/jsx-runtime";
import c from "react";
import { useFoundation as p, createComponent as g, mergeRefs as m, useClassNames as _, Tag as N } from "@rmwc/base";
import { withRipple as v } from "@rmwc/ripple";
import { useToggleFoundation as C } from "@rmwc/toggleable";
import { MDCRadioFoundation as b } from "@material/radio";
const h = (r) => {
  const { renderToggle: o, toggleRootProps: a, id: n } = C(r), { foundation: t, ...d } = p({
    props: r,
    elements: {
      rootEl: !0
    },
    foundation: ({ rootEl: i }) => new b({
      addClass: (s) => i.addClass(s),
      removeClass: (s) => i.removeClass(s)
    })
  });
  return { foundation: t, renderToggle: o, toggleRootProps: a, id: n, ...d };
}, z = g(function(o, a) {
  const { renderToggle: n, id: t, toggleRootProps: d, rootEl: i } = h(o), {
    children: s,
    className: w,
    label: x,
    style: j,
    inputRef: u,
    foundationRef: y,
    ...R
  } = o, f = /* @__PURE__ */ l(
    T,
    {
      ...i.props(d),
      ref: m(i.reactRef, a),
      children: [
        /* @__PURE__ */ e(
          "input",
          {
            ...R,
            className: "mdc-radio__native-control",
            type: "radio",
            id: t,
            ref: m(a, u)
          }
        ),
        /* @__PURE__ */ e(k, {}),
        /* @__PURE__ */ e(F, {})
      ]
    }
  );
  return n(f);
}), F = c.memo(function() {
  return /* @__PURE__ */ e("div", { className: "mdc-radio__ripple" });
}), T = v({
  surface: !1,
  unbounded: !0
})(
  c.forwardRef(
    function(o, a) {
      const { disabled: n, ...t } = o, d = _(o, [
        "mdc-radio",
        {
          "mdc-radio--disabled": n
        }
      ]);
      return /* @__PURE__ */ e(N, { ...t, className: d, ref: a });
    }
  )
), k = c.memo(function() {
  return /* @__PURE__ */ l("div", { className: "mdc-radio__background", children: [
    /* @__PURE__ */ e("div", { className: "mdc-radio__outer-circle" }),
    /* @__PURE__ */ e("div", { className: "mdc-radio__inner-circle" })
  ] });
});
export {
  z as Radio
};
